import React, { useState, useEffect } from "react";
//import Select from 'react-select';
import { Container, Row, Col } from 'react-bootstrap'
import algoliasearch from 'algoliasearch/lite';

import { SaveItem, savedSearchParams, UserObjectStoreProvider, getUserobjectData, isAuthenticated  } from "@starberry/myaccount-website-utils";

import SelectDropDown from "../FilterBox/Sections/SelectDropDown"
import {  sortByList, hasMyaccount, defaultArea_Slug, defaultArea } from '../../common/constant';
import ContentModule from "../../modules/content_module";
import "./investments.scss";
import { Link } from "gatsby";
import ListView from "../SalesCard/ListView"

import SearchResultsPagination from "../SalesCard/SearchResultsPagination_Investment";

import LeafletMapReults from "../maps/leaflet/results"

const Investments = ({Module}) => {
    const[property_list, setPropertyList] = useState({});
    const [sort_by, setSortBy] = useState(process.env.GATSBY_ALGOLIA_INDEX_NAME+"_yield_desc");
    const [sort_val, setSortVal] = useState("Select");
    const [pageNumber, setPageNumber] = useState(0);

    const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_API_KEY);

    const sort_by_options = [{value:"Yield", label:"Select"}, ...sortByList]

    const [userObjects, setUserObjects] = useState({});
    const authuser = isAuthenticated()

    useEffect(() => {
    if (authuser && hasMyaccount) {
        const getUserObjects = async () => {
            try {
                const userObjects = await getUserobjectData()
                setUserObjects(userObjects.data.data)
            } catch (e) {
                console.log("e:", e)
            }
        }
        getUserObjects()
    }
    }, [])

    useEffect(() => {
        const index = client.initIndex(sort_by ? sort_by : process.env.GATSBY_ALGOLIA_INDEX_NAME);
        
        var myfilters = "(department:residential) AND (search_type:sales) AND (status:'For Sale') AND (publish: true)"
        myfilters += "AND (officeDepartment:investments)"

        let filters = {
            filters: myfilters,
            page: pageNumber,
            hitsPerPage: 9,
        }

        index.search('', filters).then(({ nbHits, page, hitsPerPage, nbPages, hits }) => {
            let myArray = { "total": nbHits, "current_page_number": page, "hitsPerPage": hitsPerPage, "number_of_pages": nbPages, "hits": hits};

            if(nbHits > 0){
                setPropertyList(myArray)
            }
            else{
                setPropertyList([])
            }

        });
    },[sort_by, pageNumber])


    const handleChange = (val) => {
        let index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME

        if(sortByList[0].value === val){
            index_name = ""
        } else{
            if(val === "Newest"){
                index_name += "_newset"
            } else if(val === "Oldest"){
                index_name += "_oldest"
            } else if(val === "HighestPrice"){
                index_name += "_price_desc"
            } else if(val === "LowestPrice"){
                index_name += "_price_asc"
            } else if(val === "Yield"){
                index_name += "_yield_desc"
            }
        }

        setSortVal(val)
        setSortBy(index_name)
        setPageNumber(0)
    }

    const saveSearchParams = savedSearchParams({department:"residential", search_type: "sales", investmentVal:true});

    //console.log("property_list", property_list);

    return (
        <React.Fragment>
             <UserObjectStoreProvider>
                <section className="investment-block">
                    <Container>
                        <Row>
                            <Col>
                                <div className="head_section">
                                    {Module.title && <h2>{Module.title}</h2>}
                                    {Module.description && <ContentModule Content={Module.description} />}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="search_result" id="property_list">

                                    <div className="property_info">
                                        <h3>Investment property for sale in {defaultArea}<br /><span>{property_list?.total || 0} properties</span></h3>

                                        <div className="info-wrap">
                                            <div className="sort-by d-flex">
                                                <span className="sm-text">Sort:</span>
                                                <SelectDropDown
                                                    options={sort_by_options}
                                                    placeholder={sort_val}
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    handleChange={(e) => {handleChange(e.value); setSortVal(e.label)}}
                                                    //menuIsOpen={true}
                                                />
                                            </div>
                                            
                                            <SaveItem type="search" searchParams={saveSearchParams} userObjects={userObjects}>
                                                <div className="map-info create-alert d-flex">
                                                    <i className="icon-alert"></i>
                                                    <span className="info_label">Create Alert</span>
                                                </div>
                                            </SaveItem>
                                            
                                            <Link to={`/property-investments/for-sale/in-${defaultArea_Slug}/map-view/`} className="map-info map-text d-flex">
                                                <i className="icon-map-new"></i>
                                                <span className="info_label">Map <span className="d-none d-md-inline">View</span></span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="search_list features">
                                        {property_list?.hits?.length > 0 && property_list?.hits?.map((item, index) =>{
                                            return(
                                                <ListView item={item} key={index} isGridView={true} userObjects={userObjects} />
                                            )
                                        })}

                                        {(property_list?.total > property_list?.hitsPerPage) ? <SearchResultsPagination setPageNumber={setPageNumber} pageNumber={pageNumber} total={property_list?.total} current_page_number={property_list?.current_page_number} hitsPerPage={property_list?.hitsPerPage} nbPages={property_list?.number_of_pages} /> : <div className="empty-space-search"></div>}
                                    </div>
                                    
                                </div> 
                            </Col>
                        </Row>
                    </Container>
                    {/* {process.env.GATSBY_SITE_NAME === "Chase Evans" && 
                    property_list?.total > 0 &&
                    <div className={`map-section `}>
                        <LeafletMapReults
                            departmentVal={"residential"}
                            hits={property_list?.hits}
                            propertyTypeVal={""}
                            isGridView={true}
                        />
                    </div>
                    } */}
                </section>


            </UserObjectStoreProvider>
        </React.Fragment>
    );
};
export default Investments;